import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "../../components/axios";
import useFullPageLoader from "../../components/useFullPageLoader";
import Swal from "sweetalert2";
import { useUser } from "../../components/UserContext";

const SendCustomMessage = ({ open, onClose, vendorData }) => {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [customMessage, setCustomMessage] = useState("");
  const [error, setError] = useState("");
  const {userData} = useUser();
  

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!customMessage.trim()) {
      setError("Custom message is required.");
      return;
    }

    setError("");
    showLoader();

    try {
      const payload = {
        Vendor_Id: vendorData?.Vendor_Id,
        UserId: userData?.UserId,
        Org_Id: userData?.Org_Id,
        Username: userData?.Username,
        Name: `${userData?.First_Name || ''} ${userData?.Last_Name || ''}`.trim(),
        Id: vendorData?.Sr_No,
        Enquiry_Id: vendorData?.Enquiry_Id,
        Vendor_Name: vendorData?.Vendor_Name,
        Vendor_Email: vendorData?.Email,
        Vendor_Mobile: vendorData?.Mobile,
        Custom_Message: customMessage.trim(),
      };
      

      const { data } = await axios.post("/sendCustomMessage", payload);

      if (data.success) {
        Swal.fire("Success!", data.message || "Message sent successfully!", "success");
        onClose();
        setCustomMessage(""); // Clear message field
      } else {
        Swal.fire("Error!", data.message || "Failed to send message.", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error!", "Something went wrong. Please try again.", "error");
    } finally {
      hideLoader();
    }
  };

  return (
    <Modal
      show={open}
      onHide={onClose}
      size="md"
      centered
      style={{ boxShadow: "none !important" }}
    >
      <Modal.Body>
        <h5>Send Custom Message</h5>
        <hr className="p-0 mb-2" />

        <form onSubmit={handleSubmit}>
         <div className="mb-2">
        <label className="col-form-label">Name</label>
        <input
            type="text"
            className="form-control"
            value={vendorData?.Vendor_Name || ""}
            disabled
        />
        </div>


          <div className="mb-2">
            <label className="col-form-label">Mobile</label>
            <input
              type="text"
              className="form-control"
              value={vendorData?.Mobile || ""}
              disabled
            />
          </div>

          <div className="mb-2">
            <label className="col-form-label">Email</label>
            <input
              type="text"
              className="form-control"
              value={vendorData?.Email || ""}
              disabled
            />
          </div>

          <div className="mb-2">
            <label htmlFor="customMessage" className="col-form-label">
              Custom Message <span style={{ color: "red" }}>*</span>
            </label>
            <textarea
              id="customMessage"
              name="customMessage"
              className="form-control"
              value={customMessage}
              onChange={(e) => setCustomMessage(e.target.value)}
              rows="4"
            />
            {error && <p className="text-danger">{error}</p>}
          </div>

          <div className="text-center">
            <button className="btn btn-primary btn-sm mt-2" type="submit">
              Send
            </button>
          </div>
        </form>

        {loader}
      </Modal.Body>
    </Modal>
  );
};

export default SendCustomMessage;
